import React from 'react';
import { PropagateLoader } from 'react-spinners';

const Loader = props => {
  if (props.error) {
    return <div className="error">Application Error</div>;
  } else {
    return (
      <div className="l-portal__content pt-75 pb-75 text-center">
        <div className="d-inline-block loader">
          <PropagateLoader color="#65b2e8" size={20} loading={true} />
        </div>
        <br />
        {props && props.message ? (
          <h4>
            <br />
            <br />
            {props.message}
          </h4>
        ) : (
          ''
        )}
      </div>
    );
  }
};

export default Loader;
